export default "__VITE_ASSET__BoMLeePc__"